(function ($, Drupal, drupalSettings) {

  'use strict';

  var cookie_value = 'hidden';
  var effect_cookie_name = 'mp-sticky-alert-effect';

  Drupal.behaviors.mpStickyAlert = {
    attach: function (context, settings) {
      if (typeof settings.mp_block_contents === 'undefined') return;
      for (var id in settings.mp_block_contents.mp_sticky_alert) {
        var alert_settings = settings.mp_block_contents.mp_sticky_alert[id],
          $alert = $('#' + id, context),
          $close = $alert.find('[data-dismiss="sticky-alert"]'),
          cookie = Cookies.get(id) === cookie_value,
          hide_for = alert_settings.hide_for || 'session',
          duration_days = parseInt(alert_settings.duration_days) || 1,
          effect = alert_settings.effect || null
        ;

        if (!cookie) {
          $alert.prop('hidden', false);
        }

        $close
          .on('click', function () {
            var cookie_settings = {};
            if (hide_for === 'days') {
              cookie_settings['expires'] = duration_days
            }
            Cookies.set(id, cookie_value, cookie_settings);

            $alert.prop('hidden', true);

            // adjustFooter();
          })
        ;

        // Effect
        if (effect) {
          var effect_cookie_name = id + '-effect-' + effect,
            show_effect = Cookies.get(effect_cookie_name) !== cookie_value,
            effect_expires = 365 * 10
          ;
          if (show_effect) {
            // Show effect
            $(function(){
              // Chrome seems to need this delay, otherwise it appears to not
              // register the CSS rules via insertRule!
              setTimeout(function(){
                MyPlate.effect.birthdayBalloons.run();
              }, 1000);
            });

            // Mark as seen
            Cookies.set(effect_cookie_name, cookie_value, { expires: effect_expires });
          }
        }

      }
    }
  };

  // function adjustFooter() {
  //   var $footer = $('.global-footer__legal'),
  //     $alerts = $('.global-sticky-alerts'),
  //     height = `{$alerts.outerHeight(true)}px`
  //   ;

  //   $footer.css({
  //     'padding-bottom': height // TODO: magic number?
  //   });
  // }


})(jQuery, Drupal, drupalSettings);
